import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "tableOfContents"
  ]

  connect() {  
    this.createTableOfContents();
  }

  createTableOfContents() {
    const linkTemplate = "\
      <div class='mr-4 whitespace-nowrap flex items-center'> \
        <div class='w-[16px] h-[16px] {{color}}'>&nbsp;</div> \
        <a class='text-link ml-2' data-target='{{target}}' data-action='click->fhir-resources#scrollToElement'>{{name}}</a> \
      </div>";

    const colorBoxes = this.element.querySelectorAll('[data-color-box=true]');
    for (var i = 0; i < colorBoxes.length; i++) {
      const colorBox = colorBoxes[i];
      const color = colorBox.getAttribute('data-color');
      const name = colorBox.getAttribute('data-name');
      const target = '' + colorBox.id;

      var linkContents = linkTemplate.replace('{{color}}',color).replace('{{target}}', target).replace('{{name}}', name);
      var div = document.createElement('div');
      div.innerHTML = linkContents.trim();
      this.tableOfContentsTarget.appendChild(div);
    }
  }

  scrollToElement(event) {
    event.preventDefault()
    const target = event.target.getAttribute('data-target')
    const element = document.getElementById(target)
    element.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' })
  }

}
